<template>
  <div class="aiAnchor" :style="{ zIndex: aiAnchorIdex }">
    <!-- HTML5顯示背景點擊按鈕，觸發播放AI主播 -->
    <div
      class="ai-bg-pay"
      v-if="isMobile && iframeStatus && isAiAnchor"
      v-show="sceneList[0].ai_anchor.anchor_url"
    >
      <div class="frame">
        <div class="ai-anchor">
          <p>AI Anchor</p>
          <div class="ai-bg-enter">立即進入<br />開啟前所未有的體驗</div>
        </div>
        <button class="start-touring" @click="clickAiPlay">
          <a-icon type="play-circle" :style="{ fontSize: '30px' }" />
          開始導覽
        </button>
      </div>
    </div>

    <!-- AI主播 -->
    <digitalHuman
      v-if="videoDom"
      :videoDom="videoDom"
      :edit="false"
      :isMobile="isMobile"
      :displayEdit="true"
      :aiAnchorHeight="aiAnchorHeight"
    />
    <!-- AI主播所需的影片 -->
    <video
      v-if="loopPlay === 1"
      ref="videoDoms"
      id="videoDoms"
      crossorigin="anonymous"
      :src="videoUrl"
      loop
      controls
      playsinline
      muted
      style="display: none"
    ></video>
    <video
      v-else
      ref="videoDoms"
      id="videoDoms"
      crossorigin="anonymous"
      :src="videoUrl"
      controls
      playsinline
      muted
      style="display: none"
    ></video>
    <!-- 音樂 -->
    <audio
      ref="aiAnchorAudio"
      id="aiAnchorAudio"
      :src="audioSource"
      muted
    ></audio>
  </div>
</template>
<script>
import digitalHuman from "../digitalHuman/Index.vue";
import { mapGetters } from "vuex";
import { isMobile } from "../../static/js/utils/tools.js";
export default {
  data() {
    return {
      videoDom: null,
      videoUrl: null,
      oldAiData: { ai_anchor: { anchor_url: "" } },
      audioSource: null,
      iosBeginBtn: false,
      iframeStatus: true, // 是否點擊播放
      anchor_url: true,
      clickEvents: null,
      isMobile: false,
      isAiAnchor: true,
      aiAnchorIdex: 999,
      loopPlay: 0,
    };
  },
  components: {
    digitalHuman,
  },
  props: {
    sceneList: {
      type: Array,
      default: () => [],
    },
    aiAnchorHeight: {
      type: Number,
      default: 500,
    },
  },
  computed: {
    ...mapGetters(["currentScenesId"]),
  },
  watch: {
    currentScenesId: {
      handler(news) {
        if (news && this.videoDom != null) {
          this.getAiList();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (process.client) {
      window.initVideo = this.initVideo;
      window.initIosPaly = this.initIosPaly;
      window.clickAiPlay = this.clickAiPlay;
      this.videoDom = this.$refs.videoDoms;
      // 獲取影片元素的引用
      const video = this.$refs.videoDoms;
      // 添加事件監聽器以檢測播放狀態
      video.addEventListener("play", this.handlePlay);
      video.addEventListener("pause", this.handlePause);
    }
    this.isMobile = isMobile() ? true : false;
    this.isAiAnchor = this.sceneList.some(
      (item) =>
        item.ai_anchor.anchor_url &&
        JSON.stringify(item.ai_anchor.anchor_url) !== ""
    );
    this.$on("update-loopPlay", this.handleLoopPlayUpdate);
  },
  methods: {
    initVideo(auto) {
      if (process.client && !this.iframeStatus) {
        try {
          // console.log(this.iframeStatus,'iframeStatus------',auto)
          const videoDoms = this.videoDom;
          if (auto) {
            this.initMuted();
            // 掛載影片播放暫停方法
            window.editUpdateVideoStatus(false);
            videoDoms.play();
          } else {
            this.initMuted();
            // 掛載影片播放暫停方法
            window.editUpdateVideoStatus(false);
            videoDoms.play();
            let _interval = setInterval(function () {
              if (videoDoms.currentTime >= 0.1) {
                window.editUpdateVideoStatus(true);
                videoDoms.pause(); //暫停
                clearInterval(_interval);
              }
            }, 10);
          }
        } catch (error) {
          console.log("播放失敗", error);
        }
      }
    },
    // 創建一個 Promise 來等待 window.updateAiAnchor 方法載入
    waitForUpdateAiAnchor() {
      return new Promise((resolve) => {
        let set = null;
        const checkAvailability = () => {
          if (typeof window.updateAiAnchor === "function") {
            clearTimeout(set);
            resolve(); // 當方法可用時，解析 Promise
          } else {
            set = setTimeout(checkAvailability, 100); // 繼續等待
          }
        };
        checkAvailability();
      });
    },
    // 獲取數據
    async getAiList() {
      let _that = this;
      // 在客戶端執行的程式碼
      if (process.client) {
        try {
          let inde = null;
          const aiData = _that.sceneList.find((item, index) => {
            inde = index;
            return item.id == _that.currentScenesId;
          });
          if (!aiData) return;
          // 如果有路徑
          if (
            Object.keys(aiData.ai_anchor).length &&
            aiData.ai_anchor.anchor_url
          ) {
            _that.anchor_url = false;
            _that.audioSource = aiData.ai_anchor.speech_explain_url; // 音樂路徑
            // 如果路徑不相等
            if (
              _that.oldAiData.ai_anchor.anchor_url !=
              aiData.ai_anchor.anchor_url
            ) {
              _that.videoUrl =
                aiData.ai_anchor.anchor_url + "?v=" + _that.uuid2(16);
              let data = {};
              if (aiData.ai_anchor.is_auto == "1") {
                data.type = "initAuto";
              } else {
                data.type = "init";
              }
              data.value = aiData.ai_anchor;
              // 等待方法可用
              await _that.waitForUpdateAiAnchor();
              window.updateAiAnchor(data);
              // 如果路徑相等
            } else {
              const videoDoms = _that.videoDom;
              window.updateAiAnchor({ type: "", value: aiData.ai_anchor });
              // 如果路徑相等且不自動播放
              if (aiData.ai_anchor.is_auto == 0) {
                window.editUpdateVideoStatus(true);
                videoDoms.pause();
              }
              if (
                _that.oldAiData.ai_anchor.is_auto == 0 &&
                aiData.ai_anchor.is_auto == 1
              ) {
                _that.initMuted();
                window.editUpdateVideoStatus(false);
                videoDoms.play();
              }
              if (
                _that.oldAiData.ai_anchor.is_auto == 1 &&
                aiData.ai_anchor.is_auto == 1 &&
                inde == 0
              ) {
                _that.initMuted();
                window.editUpdateVideoStatus(false);
                videoDoms.play();
              }
            }
            // 如果沒有路徑
          } else {
            if (!_that.anchor_url) {
              window.updateAiAnchor({ type: "del", value: "" });
              _that.videoUrl = null;
              _that.audioSource = null;
              const videoDoms = _that.videoDom;
              videoDoms.pause();
            }
          }
          _that.oldAiData = JSON.parse(JSON.stringify(aiData));
        } catch (error) {
          console.error("無法調用window.updateAiAnchor:", error);
        }
      }
    },
    // 播放音樂
    handlePlay() {
      if (this.audioSource) {
        const audio = this.$refs.aiAnchorAudio;
        audio.play();
      }
    },
    // 暫停音樂
    handlePause() {
      if (this.audioSource) {
        const audio = this.$refs.aiAnchorAudio;
        audio.pause();
      }
    },
    isIos() {
      // 檢查是否是iOS裝置
      const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      // 處理iOS自動播放的問題
      if (isiOS) {
        this.iosBeginBtn = true;
      }
    },
    beginAi() {
      this.videoDom.play();
      this.iosBeginBtn = false;
    },
    // 媒體是否靜音
    initMuted() {
      const videoElement = document.getElementById("videoDoms");
      const aiAnchorAudio = document.getElementById("aiAnchorAudio");
      videoElement.muted = false;
      aiAnchorAudio.muted = false;
    },
    // 開始點擊事件，添加影片自動播放
    async initIosPaly(element) {
      // 在客戶端執行的程式碼
      if (process.client) {
        const that = this;
        element.addEventListener("click", function () {
          that.clickAiPlay();
        });
      }
    },
    // 點擊頁面播放
    clickAiPlay() {
      const that = this;
      this.aiAnchorIdex = 700;
      if (that.iframeStatus) {
        try {
          const aiData = that.sceneList.find(
            (item) => item.id == that.currentScenesId
          );
          this.oldAiData = { ai_anchor: { anchor_url: "" } };
          if (!aiData) return;
          // 如果有路徑
          if (
            Object.keys(aiData.ai_anchor).length &&
            aiData.ai_anchor.anchor_url
          ) {
            // 音樂路徑
            that.audioSource = aiData.ai_anchor.speech_explain_url;
            // 有影片不自動播放
            if (aiData.ai_anchor.is_auto == "0") {
              const videoElement = that.$refs.videoDoms;
              const aiAnchorAudio = that.$refs.aiAnchorAudio;
              // 播放影片
              videoElement.play();
              // 播放音樂 音樂是否為空
              that.audioSource ? aiAnchorAudio.play() : "";
              // 暫停影片
              videoElement.pause();
              // 暫停音樂
              that.audioSource ? aiAnchorAudio.pause() : "";
            }
          }
          that.iframeStatus = false;
          that.$nextTick(() => {
            that.getAiList();
          });
        } catch (error) {
          that.iframeStatus = false;
          console.log(error, "iOS自動播放");
        }
      }
    },
    uuid2(len, radix) {
      var chars =
        "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
          ""
        );
      var uuid = [],
        i;
      radix = radix || chars.length;
      if (len) {
        for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
      } else {
        var r;
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
        uuid[14] = "4";
        for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | (Math.random() * 16);
            uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
          }
        }
      }
      return uuid.join("");
    },
    handleLoopPlayUpdate(newLoopPlayValue) {
      this.loopPlay = newLoopPlayValue;
    },
  },
};
</script>
<style lang="less" scoped>
.aiAnchor {
  position: relative;
  .ai-bg-pay {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 600;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .frame {
      z-index: -50;
      width: 100vw;
      height: 460px;
      background-image: url("/images/kr/ai-anchor-frame.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .ai-anchor {
      z-index: -10;
      color: #fff;
      background-image: url("/images/kr/ai-anchor-bg.png");
      width: 280px;
      height: 175px;
      background-repeat: no-repeat;
      display: flex;
      flex-direction: column;
      align-items: center;
      p {
        width: 120px;
        // background-color: rgba(0, 0, 0, 0.5);
        position: relative;
        z-index: -1;
        font-size: 18px;
        margin-bottom: 0;
        text-align: center;
        margin-top: -13px;
      }
    }

    .ai-bg-enter {
      position: relative;
      display: flex;
      flex-direction: column;
      text-align: center;
      gap: 12px;
      color: #fff;
      font-size: 18px;
      padding: 40px 35px;
      background: linear-gradient(
          to right,
          rgba(255, 255, 255, 0.1) 1px,
          transparent 1px
        ),
        linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0.1) 1px,
          transparent 1px
        ),
        rgba(50, 123, 127, 0.7);
      background-repeat: repeat;
      background-size: 5px 5px;
    }
    .ai-bg-enter::before {
      z-index: -5;
      content: "";
      position: absolute;
      width: 7px;
      height: 7px;
      background-color: rgba(255, 255, 255);
      border-radius: 50px;
      box-shadow: 0 0 10px 6px #2ea7e0;
      filter: brightness(1.2);
      animation: circle 3s linear infinite;
    }
    .start-touring {
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 20;
      gap: 12px;
      color: #fff;
      font-size: 18px;
      border-radius: 50px;
      border: 1px solid #fff;
      background: #015c61;
      padding: 8px 12px;
      margin-top: -25px;
    }
  }
  @keyframes circle {
    // 右上
    0%,
    100% {
      top: -17px;
      left: 257px;
    }
    // 讓AI Anchor不會壓到光點
    9%,
    22% {
      visibility: hidden;
    }
    // 左上
    31% {
      visibility: visible;
      top: -17px;
      left: -23px;
    }
    // 左下
    50% {
      top: 155px;
      left: -23px;
    }
    // 右下
    81% {
      top: 155px;
      left: 257px;
    }
  }
}
</style>
